export const AUTH_LAYOUT_LEFT_DRAWER_OPENED_WIDTH = 240;
